var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeViewRoot',{attrs:{"items":_vm.items,"parent":_vm.parent,"opened":_vm.opened,"on-change-open":_vm.onChangeOpen,"identifier":_vm.identifier,"on-create":_vm.onCreate,"on-save":_vm.onSave,"on-delete":_vm.onDelete,"refresh-tree":_vm.refreshTree,"get-items":_vm.getItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }